import React, {  useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUtensils, FaListAlt, FaDollarSign, FaUserCircle, FaQrcode } from 'react-icons/fa'; // Importing icons from FontAwesome
import AuthContext from "../AuthContext"; 


const Dashboard = () => {
  const {  isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  //if user is not logged in, redirect to login page
  useEffect(() => {
    if (!isLoggedIn) {
      console.log("User is not logged in. Redirecting to login page.");
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);


  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <div className="container mx-auto px-6">
        {/* Dashboard Heading */}
        <h1 className="text-4xl font-bold text-gray-800 text-center mb-10">
          Dashboard
        </h1>

        {/* Dashboard Options - Large Cards witsah Icons */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Live Orders Card - First */}
          <div
            onClick={() => navigate('/live-orders')}
            className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transform transition duration-300 hover:scale-105 cursor-pointer flex flex-col items-center"
          >
            <FaListAlt className="h-16 w-16 text-green-500 mb-4" /> {/* Icon */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">Live Orders</h2>
            <p className="text-gray-600 text-center">
              View and manage live customer orders. Track incoming orders and their statuses in real-time.
            </p>
          </div>

          {/* Today's Sales Card - Second */}
          <div
            onClick={() => navigate('/todays-sales')}
            className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transform transition duration-300 hover:scale-105 cursor-pointer flex flex-col items-center"
          >
            <FaDollarSign className="h-16 w-16 text-yellow-500 mb-4" /> {/* Icon */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">Today's Sales</h2>
            <p className="text-gray-600 text-center">
              View today's total sales and earnings. Analyze the revenue generated by your restaurant.
            </p>
          </div>

          {/* Edit Menu Card - Third */}
          <div
            onClick={() => navigate('/edit-menu')}
            className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transform transition duration-300 hover:scale-105 cursor-pointer flex flex-col items-center"
          >
            <FaUtensils className="h-16 w-16 text-blue-500 mb-4" /> {/* Icon */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">Edit Menu</h2>
            <p className="text-gray-600 text-center">
              Manage your restaurant's menu items. Add, edit, or delete dishes, and update prices.
            </p>
          </div>

          {/* My Account Status Card - Fourth */}
          <div
            onClick={() => navigate('/account-status')}
            className="bg-white shadow-lg rounded-lg p-6 hidden hover:shadow-2xl transform transition duration-300 hover:scale-105 cursor-pointer flex flex-col items-center"
          >
            <FaUserCircle className="h-16 w-16 text-purple-500 mb-4" /> {/* Icon */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">My Account Status</h2>
            <p className="text-gray-600 text-center">
              Check your account details, subscription status, and settings. Manage your account preferences.
            </p>
          </div>

          {/* Download Qr code card  */}

          <div
            onClick={() => navigate('/QrCode')}
            className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transform transition duration-300 hover:scale-105 cursor-pointer flex flex-col items-center"
          >
            <FaQrcode className="h-16 w-16 text-orange-400 mb-4" /> {/* Icon */}
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">Download QR Code</h2>
            <p className="text-gray-600 text-center">
              Download QR code for your restaurant.
            </p>
          </div>


        </div>
      </div>
    </div>
  );
};

export default Dashboard;
